var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twitter",
    d: "M15.139,2.991c.01.131.01.263.01.394A8.908,8.908,0,0,1,5.819,12,9.833,9.833,0,0,1,.784,10.641a7.343,7.343,0,0,0,.792.037A6.921,6.921,0,0,0,5.647,9.384a3.264,3.264,0,0,1-3.066-2.1,4.47,4.47,0,0,0,.619.047,3.74,3.74,0,0,0,.863-.1A3.1,3.1,0,0,1,1.434,4.256V4.219A3.512,3.512,0,0,0,2.916,4.6,2.973,2.973,0,0,1,1.454,2.081,2.832,2.832,0,0,1,1.9.553,9.6,9.6,0,0,0,8.662,3.722a3.167,3.167,0,0,1-.081-.694A3.16,3.16,0,0,1,11.86,0a3.4,3.4,0,0,1,2.4.956A6.79,6.79,0,0,0,16.337.225,3.077,3.077,0,0,1,14.9,1.894a7.007,7.007,0,0,0,1.888-.469A6.78,6.78,0,0,1,15.139,2.991Z",
    transform: "translate(-0.784)",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.efff54bc93136231fa01f5afe696f713.svg";
export { ForwardRef as ReactComponent };